import React from 'react'
import { useSelector } from 'react-redux'
import _ from 'lodash'

import { getBrand } from '../../redux/reducers/configuration'
import { getTourTitle } from '../../redux/reducers/tourDetails'
import labels, {brandBreadCrumbLabel} from '../../configuration/labels'
import '../../styles/scss/elements/site-navigation.scss'

const SiteNavigation = () => {
  const baseUrl = _.get(window, 'location.origin')
  const brand = useSelector(getBrand)
  const breadCrumb = brandBreadCrumbLabel[brand]
  const tourTitle = useSelector(getTourTitle)
  return (
    <div className="u-flex site-navigation">
      <a className="u-flex u-flex-align-center" href={baseUrl}>
        {labels.home}
      </a>
      <a className="u-flex u-flex-align-center" href={`${baseUrl}/${breadCrumb && breadCrumb.toLowerCase()}`}>
        {breadCrumb}
      </a>
      <span>{tourTitle}</span>
    </div>
  )
}

export default SiteNavigation
